<rr-card>
  <span class="searchbar" *ngIf="inputData$ | async as input">
    <span class="oi rr-back-button" (click)="onBackClicked()"></span>
    <span class="oi oi-magnifying-glass"></span>

    <input
      #inputText
      type="text"
      [placeholder]="input.placeholder"
      (keyup)="detectChanges($event)"
      (change)="detectChanges($event)"
      [value]="this.filterValue"
    />
  </span>
</rr-card>
